import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { SettingsHub } from '@/features/settings/SettingsHub'

const settingsSearchSchema = z.object({
  section: z.string().optional(),
})

export const Route = createFileRoute('/settings/')({
  validateSearch: settingsSearchSchema,
  component: SettingsPage,
  staticData: { authorize: true, requiresAccount: false },
})

function SettingsPage() {
  const { section } = Route.useSearch()
  return <SettingsHub initialSection={section} />
}
